/**
 * ------------IMPORTANT--------------
 * THIS OBJECT WILL BE USED BY ApplicationContext.js
 * And Webpack

 * Author: Kevin Li
 * 2018-01-25
 *
 */

var SiteConfig = function (env, buildNumber) {

    var Local = {
        assetUrlPrefix: "//local.library.io:8080",
        componentEditor: "https://editor-component-beta.library.io",
        symbolEditor: "https://editor-symbol-beta.library.io",
        footprintEditor: "https://editor-footprint-beta.library.io",
        packageEditor: "https://editor-package-beta.library.io",//"http://local.library.io:8712/app/package-editor/index_local.html",
        packageLibrary: "https://editor-library-beta.library.io",
        adskAccountUrl: "https://accounts-staging.autodesk.com",
        tealiumURL: "https://tags.tiqcdn.com/utag/autodesk/library-io-qa/qa/utag.js",
        gaAccount: "UA-33214819-10",
        defaultUserAvatar: "https://cdn.accounts-stg.autodesk.com/content/identity/28.0.316.df1338e/z/Content/images/icons/user_X80.png",
        contentServer: {
            server: "http://local.library.io:3002",
            dataModelVersion: "datamodel_version=9",
            tenant: "123D-Circuits",
            type: "libraries",
            examplesHubId: "43184"
        },
        homeRegion: "us"
    };

    // Run the local site against the deployed STAGING content server. Requires
    // running over HTTPS on local.library.io (see `npm run local_staging`)
    var Local_Staging = {
        assetUrlPrefix: "//local.library.io:8080",
        componentEditor: "https://editor-component-staging.library.io",
        symbolEditor: "https://editor-symbol-staging.library.io",
        footprintEditor: "https://editor-footprint-staging.library.io",
        packageEditor: "https://editor-package-staging.library.io",
        packageLibrary: "https://editor-library-staging.library.io",
        adskAccountUrl: "https://accounts-staging.autodesk.com",
        tealiumURL: "https://tags.tiqcdn.com/utag/autodesk/library-io-qa/qa/utag.js",
        gaAccount: "UA-33214819-10",
        defaultUserAvatar: "https://cdn.accounts-stg.autodesk.com/content/identity/28.0.316.df1338e/z/Content/images/icons/user_X80.png",
        contentServer: {
            server: "https://api-staging.library.io",
            dataModelVersion: "datamodel_version=9",
            tenant: "123D-Circuits",
            type: "libraries",
            examplesHubId: "2011548"
        },
        homeRegion: "us"
    };

    var Dev = {
        assetUrlPrefix: "https://assets-dev.library.io/assets-" + buildNumber,
        componentEditor: "https://editor-component-beta.library.io",
        symbolEditor: "https://editor-symbol-beta.library.io",
        footprintEditor: "https://editor-footprint-beta.library.io",
        packageEditor: "https://editor-package-beta.library.io",
        packageLibrary: "https://editor-library-beta.library.io",
        adskAccountUrl: "https://accounts-staging.autodesk.com",
        tealiumURL: "https://tags.tiqcdn.com/utag/autodesk/library-io-qa/qa/utag.js",
        contentServer: {
            server: "https://api-beta.library.io",
            dataModelVersion: "datamodel_version=9",
            tenant: "123D-Circuits",
            type: "libraries",
            examplesHubId: "43184"
        },
        homeRegion: "us"
    };

    var Staging = {
        assetUrlPrefix: "https://assets-staging.library.io/assets-" + buildNumber,
        componentEditor: "https://editor-component-staging.library.io",
        symbolEditor: "https://editor-symbol-staging.library.io",
        footprintEditor: "https://editor-footprint-staging.library.io",
        packageEditor: "https://editor-package-staging.library.io",
        packageLibrary: "https://editor-library-staging.library.io",
        adskAccountUrl: "https://accounts-staging.autodesk.com",
        tealiumURL: "https://tags.tiqcdn.com/utag/autodesk/library-io-qa/qa/utag.js",
        contentServer: {
            server: "https://api-staging.library.io",
            dataModelVersion: "datamodel_version=9",
            tenant: "123D-Circuits",
            type: "libraries",
            examplesHubId: "2011548"
        },
        homeRegion: "us"
    };

    var Production = {
        assetUrlPrefix: "https://assets.library.io/assets-" + buildNumber,
        componentEditor: "https://editor-component.library.io",
        symbolEditor: "https://editor-symbol.library.io",
        footprintEditor: "https://editor-footprint.library.io",
        packageEditor: "https://editor-package.library.io",
        packageLibrary: "https://editor-library.library.io",
        adskAccountUrl: "https://accounts.autodesk.com",
        tealiumURL: "https://tags.tiqcdn.com/utag/autodesk/library-io/prod/utag.js",
        gaAccount: "UA-33214819-9",
        defaultUserAvatar: "https://cdn.accounts-stg.autodesk.com/content/identity/28.0.316.df1338e/z/Content/images/icons/user_X80.png",
        contentServer: {
            server: "https://api.library.io",
            dataModelVersion: "datamodel_version=9",
            tenant: "123D-Circuits",
            type: "libraries",
            examplesHubId: "403147"
        },
        homeRegion: "us"
    };

    var result

    switch (env) {
        case "production":
            result = Object.assign({}, result, Production);
            break;
        case "staging":
            result = Object.assign({}, result, Staging);
            break;
        case "dev":
            result = Object.assign({}, result, Dev);
            break;
        case "local_staging":
            result = Object.assign({}, result, Local_Staging);
            break;
        case "local":
            result = Object.assign({}, result, Local);
            break;
        default:
            throw `Unknown environment: ${env}`
    }

    result.toSCSSEnv = function(config) {
        var str = "";
        for(var key in result) {
            let value = result[key]
            if(typeof(value) == "string") {
                if (key == "assetUrlPrefix") {
                    value = '../'
                }
                str += `$${key}: '${value}'; `;
            }
        }
        return str;
    };

    return result;
};

SiteConfig.env = function () {
        const hostname = window.location.hostname
        const envs = {
            'dev.library.io': 'dev',
            'staging.library.io': 'staging',
            'stg-test.library.io': 'staging',
            'library.io': 'production',
            'prd-test.library.io': 'production'
        }

        let env = process.env.ENV || 'local'
        if (envs.hasOwnProperty(hostname)) {
            env = envs[hostname]
        }
        console.log(`hostname: ${hostname}, env: ${env}`)
        return env
}

module.exports = SiteConfig;

